import { FormEvent, useEffect, useState } from "react";
import Button from "../../shared/components/UI/Button";
import MarginBox from "../../shared/components/other/MarginBox";
import Navbar from "../../shared/components/navbar/NavBar";
import MultiSelect from "../../shared/components/UI/MultiSelect";
import Footer from "../../shared/components/other/Footer";
import "./calendar.scss";
import CalendarComponent from "./components/CalendarComponent";
import GameCard from "./components/GameCard";
import useEventCards from "../../shared/hooks/useEventCards";
import { useSearchParams } from "react-router";
import {
  convertEventsDTOToUrlParams,
  convertToEventsDTO,
  convertToEventsForm,
  EventsDTO,
  EventsForm,
} from "./types/CalendarTypes";
import { useForm } from "react-hook-form";
import useEventFilterTypes from "./hooks/useFilters";
import { W } from "react-router/dist/development/fog-of-war-Ckdfl79L";
import { displayNotImplemented } from "../../shared/services/Notifications/NotificationServices";

// Убрать баг с мерцанием календаря при наведении на кнопки

// ФИльтры с чекбоксами регистрируем через register
// Если быстрый фильтр повторяез значение из select - То вручную менять фильтр который в селекуте а не подписывать чекбоксы на всякое
// Понять разницу между control и useField
//дсонединить х с кнопкой
//Не забудь про запрос на увеличение выборки
//Исправить таймзону календаря
//\настроить календарь на даты назад
// конечная дата - включительно (исправлено костылем)
// добавить поиск (согласовать с бэком)
// добавить филтрацию (солгласовать с бэком)

//согласовать поведение селекта если чебкосы выбраны, но нужно его закрыть

export default function Calendar() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [filterTypes, isLoadingF, errorF] = useEventFilterTypes();

  const limit = 16;

  const { handleSubmit, control, getValues, setValue, watch, register, reset } =
    useForm<EventsForm>({
      defaultValues: { offset: 0, limit: limit },
    });

  const [startDate, endDate] = watch(["date_from", "date_to"]);

  const [activeFilters, setActiveFilters] = useState<EventsForm>({});

  let {
    cardsData,
    isFetched,
    error,
    refetch,
    cardsCount,
    fetchNextPage,
    hasNextPage,
  } = useEventCards(activeFilters);

  // Автоматическая отправка при выборе обеих дат
  useEffect(() => {
    if ((startDate && endDate) || !(startDate || endDate)) {
      handleSubmit(onSubmit)();
    }
  }, [startDate, endDate, handleSubmit]);

  const formData = watch();

  const cardElements = cardsData.map((card: any, index: any) => {
    return (
      <GameCard
        key={index}
        openState={card.state}
        peopleCount={card.count_participants_total || "0"}
        name={card.name}
        dateTime={card.start_datetime}
        place={card.place}
        imgSrc={card.images}
        tags={card.tags?.map((el: any) => el.name)}
        slug={card.slug}
      />
    );
  });

  const onSubmit = (form: EventsForm) => {
    setActiveFilters(form);

    const params: any = convertEventsDTOToUrlParams(convertToEventsDTO(form));
    setSearchParams(params);
    refetch();
  };

  const handleReset = () => {
    reset();
    refetch();
  };

  const handleShowMore = () => {
    fetchNextPage();
  };

  const cardsLeft = Math.max(cardsCount - cardsData.length, 0);

  const cardsToShow = Math.min(limit, cardsLeft);

  const showMoreButton = hasNextPage && (
    <Button darkStyle className="calendar-moreButton" onClick={handleShowMore}>
      Показать ещё {cardsToShow} из {cardsLeft}
    </Button>
  );

  return (
    <MarginBox>
      <header>
        <Navbar />
      </header>
      <main className="main">
        {/* <Button onClick={() => {
                    console.log('clicked')
                    setArrSt((last) => {
                        return 'не а';
                    })
                }}></Button> */}
        <h1>События в Санкт-Петербурге</h1>
        <form className="calendar-filters" onSubmit={handleSubmit(onSubmit)}>
          <CalendarComponent
            startDateName="date_from"
            endDateName="date_to"
            getValues={getValues}
            setValue={setValue}
          />
          <div className="calendar-filters-container">
            <div className="calendar-filters-flex">
              <Button
                darkStyle
                onClick={displayNotImplemented}
                className="calendar-filters-input calendar-filters-input-iconed"
              >
                <img
                  src="/calendar/searchIcon.svg"
                  alt="Искать"
                  className="calendar-filters-icon"
                />
              </Button>
              {/* Должно быть чекбоксом */}
              <Button
                darkStyle
                onClick={displayNotImplemented}
                className="calendar-filters-input  calendar-filters-input-iconed"
              >
                <img
                  src="/calendar/filterIcon.svg"
                  alt="Фильтровать"
                  className="calendar-filters-icon"
                />
              </Button>
              {/* <Button className='calendar-filters-input'>Все</Button>
                            <Button className='calendar-filters-input'>Выставки</Button>
                            <Button className='calendar-filters-input'>Игры</Button> */}
              {/* <Select className='calendar-filters-input' title='Вид мероприятия'></Select>
                            <Select className='calendar-filters-input' title='Тип мероприятия'></Select> */}
              <MultiSelect
                className="calendar-filters-input"
                hasSearch={true}
                title="Тип мероприятия"
                name="type"
                items={filterTypes?.types}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                hasSearch={true}
                title="Подтип"
                name="subtype"
                items={filterTypes?.subtypes}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                hasSearch={true}
                title="Статус"
                name="state"
                items={filterTypes?.states}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                hasSearch={true}
                title="Регистрация"
                name="reg_type"
                items={filterTypes?.reg_types}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              {/* <div className='defaultInput calendar-filters-input'><Button refStyle><img className='calendar-filters-dateReset-icon' src="/UI/closeIcon.svg" alt="Сбросить" /></Button>9-16 ноября</div> */}
              <Button
                className="calendar-filters-input calendar-filters-resetButton"
                darkStyle
                onClick={handleReset}
                type="submit"
              >
                <img
                  className="calendar-filters-reset-icon"
                  src="/UI/closeIcon.svg"
                  alt="Сбросить"
                />
              </Button>
            </div>
            <div className="calendar-filters-region">
              <img src="/calendar/placeIcon.svg" alt="" />
              <a className="calendar-filters-region-text" href="#root">
                Санкт-Петербург
              </a>
            </div>
          </div>
          {/* <SelectMenu title='Город'/> */}
          {/* <SelectMenu title='Город'/> */}
        </form>
        <div className="calendar-cards">
          <div className="calendar-cards-wrapper">
            {!isFetched ? "Загрузка" : null}
            {cardElements}
          </div>
        </div>
        {showMoreButton}
      </main>
      <Footer />
    </MarginBox>
  );
}
